module.exports = __webpack_public_path__ + "static/media/galerija_2013 (17).054179bc.JPG";